/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_Col_FitInputs */

const en_cap_money_mock_col_fit = /** @type {(inputs: Cap_Money_Mock_Col_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit`)
};

const lv_cap_money_mock_col_fit = /** @type {(inputs: Cap_Money_Mock_Col_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilstība`)
};

/**
* | output |
* | --- |
* | "Fit" |
*
* @param {Cap_Money_Mock_Col_FitInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_col_fit = /** @type {((inputs?: Cap_Money_Mock_Col_FitInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_Col_FitInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_col_fit(inputs)
	return en_cap_money_mock_col_fit(inputs)
});